import { Box, SearchField, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import useSearch from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Employees } from 'modules/employees/store/collections/employees'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

import Body from './Body'
import Header from './Header'
import { AccessGroupTableContext } from './context'

interface Props {
  accessGroup: AccessGroup
  surveyId: string
  employees: Employees
}

function AccessGroupTable({ accessGroup, surveyId, employees }: Props) {
  const { search, onSearch } = useSearch()
  const accessGroupId = accessGroup.attributes.id
  const accessGroupStrategy = accessGroup.attributes.strategy

  const { loading } = useAsyncData(async () => {
    if (accessGroupStrategy !== AccessGroup.Strategies.members) return

    return formAccessGroupMemberships.fetch({
      data: {
        access_group_id: accessGroupId,
        form_id: surveyId,
      },
    })
  }, [accessGroupId, accessGroupStrategy])

  const TableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <AccessGroupTableContext.Provider value={loading}>
      <Table options={TableOptions}>
        <Header />
        <Body search={search} accessGroup={accessGroup} employees={employees} />
      </Table>
    </AccessGroupTableContext.Provider>
  )
}

export default observer(AccessGroupTable)
